import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import { abbreviateNumber, fullNumber } from "../../../utils/numberFormatting.utils";
import { getCloudConversionsTableData } from "./CloudConversions.utils";
export const Cell = _styled("div", {
  target: "eoia0cc0",
  label: "Cell"
})(process.env.NODE_ENV === "production" ? {
  name: "o6l5fu",
  styles: "padding:5px 0;"
} : {
  name: "o6l5fu",
  styles: "padding:5px 0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
export const CloudConversionsHeader = {
  cells: [{
    key: 'string',
    content: 'App',
    isSortable: true,
    style: {
      minWidth: '250px'
    }
  }, {
    key: 'evaluations',
    content: 'Evaluations',
    isSortable: true
  }, {
    key: 'conversions',
    content: 'Conversions',
    isSortable: true
  }, {
    key: 'conversionRate',
    content: 'Conversion rate',
    isSortable: true
  }]
};
export const getCloudConversionsBody = cloudConversionsAPIResponse => {
  if (!cloudConversionsAPIResponse) {
    return [];
  }

  const cloudConversionsTableData = getCloudConversionsTableData(cloudConversionsAPIResponse);
  return cloudConversionsTableData.map(item => ({
    key: item.appKey,
    cells: [{
      key: item.appName,
      content: /*#__PURE__*/React.createElement(Cell, null, item.appName)
    }, {
      key: item.evaluations,
      content: /*#__PURE__*/React.createElement(Tooltip, {
        content: fullNumber(item.evaluations)
      }, /*#__PURE__*/React.createElement("span", null, abbreviateNumber(item.evaluations)))
    }, {
      key: item.conversions,
      content: /*#__PURE__*/React.createElement(Tooltip, {
        content: fullNumber(item.conversions)
      }, /*#__PURE__*/React.createElement("span", null, abbreviateNumber(item.conversions)))
    }, {
      key: item.conversationRate,
      content: "".concat(item.conversationRate, "%")
    }]
  }));
};